export const PRIORITY_KEYMAP = {
  Urgent: 'URGENT',
  High: 'HIGH',
  Medium: 'MEDIUM',
  Low: 'LOW',
} as const;

/**
 * Red for High, yellow for Medium, green for Low - the traffic-light reading everyone
 * already expects. Urgent keeps a darker red so it stays distinguishable from High now
 * that High owns plain red.
 *
 * Every screen that shows a priority reads these, so a colour changed here changes it
 * across the whole app.
 */
export const PRIORITY_COLORS: Record<string, string> = {
  URGENT: '#b3001b',
  HIGH: '#e53935',
  MEDIUM: '#fdc500',
  LOW: '#00ac46',
};

/**
 * The colour for a priority however it is spelled - the enum (`HIGH`) on the task screens,
 * or the plain label (`High`) the Assign Work form and the analyst API use.
 */
export const priorityColor = (priority: string | null | undefined): string | undefined => {
  if (!priority) return undefined;
  const key = String(priority).toUpperCase();
  return PRIORITY_COLORS[key];
};

export const PRIORITY_LABELS: Record<string, string> = {
  URGENT: 'Urgent',
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
};

export const TASK_PRIORITY = {
  URGENT: 'URGENT',
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW',
} as const;

export type TaskPriority = (typeof TASK_PRIORITY)[keyof typeof TASK_PRIORITY];

export const TASK_PRIORITY_ORDER: TaskPriority[] = [
  TASK_PRIORITY.URGENT,
  TASK_PRIORITY.HIGH,
  TASK_PRIORITY.MEDIUM,
  TASK_PRIORITY.LOW,
];

export const TASK_PRIORITY_WEIGHT: Record<string, number> = {
  URGENT: 4,
  HIGH: 3,
  MEDIUM: 2,
  LOW: 1,
};
